<wvr-nav-list-component [aligned]="aligned" [vertical]="vertical">
  <template nav-list-items>
    <ng-content select="wvre-nav-li, tl-nav-li" ngProjectAs="wvre-nav-li"></ng-content>
  </template>
</wvr-nav-list-component>